import { toCamelCaseDeep } from 'src/utils/transform';
import MemriseApi from '../MemriseApi';
import * as Types from './types';
import * as Schema from './schema';
import { FeatureTokenType } from './types';

export default class MonetisationApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/me' });
  }

  public async getFeaturesTokensAvailability(
    languagePairId: number,
  ): Promise<Types.FeatureTokenAvailability[]> {
    try {
      const response = await this.get<Schema.FeaturesTokensAvailabilityResponse>(
        `/language_pairs/${languagePairId}/features/availability/`,
      );
      return toCamelCaseDeep(response).features;
    } catch (e) {
      // failures in token availability checks are ignored
      return [];
    }
  }

  public async getFeatureTokenAvailability(
    languagePairId: number,
    tokenType: FeatureTokenType,
  ): Promise<Types.FeatureTokenAvailabilityState> {
    const features = await this.getFeaturesTokensAvailability(languagePairId);
    const feature = features.find(f => f.type === tokenType);

    return !feature ? 'not-found' : feature.available ? 'available' : 'not-available';
  }

  public async consumeFeatureToken(
    languagePairId: number,
    tokenType: FeatureTokenType,
  ): Promise<void> {
    try {
      await this.post(`/language_pairs/${languagePairId}/features/${tokenType}/engage/`, {});
    } catch (e) {
      // failures in token consumption are ignored
      return;
    }
  }
}

export const MonetisationApi = new MonetisationApiClass();
